<template>
    <small>{{detail}}</small>
</template>


<script>
    export default {
        name: "step-header",
        props:['step'],
        computed: {
            detail ()  {
                var detail = ''
                if(Array.isArray(this.step.detail)) {
                    for (var tag in this.step.detail) {
                        var id = this.step.detail[tag]
                        var item = this.step.inputs.filter(function (el) {
                            return el.id === id
                        })[0];
                        if (item && item.value) detail += item.value + ' '
                    }
                } else {
                    detail = this.step.detail
                }
                return  detail
            },
        }

    }
</script>

<style scoped>

</style>